import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { InputContainer } from '../../../../common/form/FormElements.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import PollForm from '../../../CMSPages/Polls/PollsEdit/PollForm.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import PropTypes from 'prop-types';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';

const PollsVoteForm = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  return (
    // <div className="poll-form-component">
    <div className="poll-form-component">
      <Form
        onFinish={onSubmit}
        initialValues={initialValues}
        form={form}
        layout="vertical"
        style={{ margin: '10px' }}
      >
        <InputContainer>
          {initialValues.questions.map((field, index) => (
            <div key={'q' + index}>
              <div>
                <FormSelect
                  style={{
                    width: '100%',
                  }}
                  name={[field.response_collection_id, 'response_id']}
                  label={field.name}
                  key={'qu' + index}
                  options={field.responses?.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  rules={[required(t)]}
                />
              </div>
            </div>
          ))}
        </InputContainer>

        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'polls'}>
            {t('Hlasovať v ankete')}
          </FormButton>
        </FormButtonsContainer>
      </Form>
    </div>
  );
};

PollForm.propTypes = {
  initialValues: PropTypes.any,
  onSubmit: PropTypes.func,
  pollDetail: PropTypes.object,
};

export default PollsVoteForm;
